var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 54,
    viewBox: "0 0 80 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ooui:quotes-ltr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.9999 -2.00024L31.9999 -10.0002H23.9999C15.1599 -10.0002 7.99988 1.15976 7.99988 9.99976V37.9998H35.9999V9.99976H19.9999C19.9999 -2.00024 27.9999 -2.00024 27.9999 -2.00024ZM55.9999 9.99976C55.9999 -2.00024 63.9999 -2.00024 63.9999 -2.00024L67.9999 -10.0002H59.9999C51.1599 -10.0002 43.9999 1.15976 43.9999 9.99976V37.9998H71.9999V9.99976H55.9999Z",
    fill: "#424759"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.f4f55ab5aa505ee787fab8dae028d45c.svg";
export { ForwardRef as ReactComponent };